class StartLiveStatus {
    static Invalid = 0;
    static Disconnected = 1;
    static LoadingAsset =  2;
    static WaitingForTransition = 3;
    static Connected = 4;
    static WaitingForEndOfShow = 5;
    static WaitingForEndOfSyndication = 6;
}

export default StartLiveStatus;